import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tag, UserRound } from "lucide-react";
import { api } from "@/lib/api";

export const QueryField = ({ value, onChange, onSearch, className }) => {
  const nav = useNavigate();
  const [sug, setSug] = useState({ categories: [], providers: [] });
  const [open, setOpen] = useState(false);
  const [idx, setIdx] = useState(-1);
  useEffect(() => {
    const q = value.trim();
    if (q.length < 2) { setSug({ categories: [], providers: [] }); return; }
    const t = setTimeout(() => { api.get("/suggest", { params: { q } }).then((r) => { setSug(r.data); setIdx(-1); }).catch(() => {}); }, 200);
    return () => clearTimeout(t);
  }, [value]);
  const rows = [...sug.categories.map((c) => ({ kind: "cat", ...c })), ...sug.providers.map((p) => ({ kind: "prov", ...p }))];
  const pick = (r) => {
    setOpen(false);
    if (r.kind === "prov") { nav(`/artista/${r.id}`); return; }
    onChange(r.label);
    onSearch(r.label);
  };
  const onKey = (e) => {
    if (e.key === "ArrowDown" && rows.length) { e.preventDefault(); setOpen(true); setIdx((i) => (i + 1) % rows.length); }
    else if (e.key === "ArrowUp" && rows.length) { e.preventDefault(); setIdx((i) => (i <= 0 ? rows.length - 1 : i - 1)); }
    else if (e.key === "Escape") { setOpen(false); }
    else if (e.key === "Enter") { e.preventDefault(); if (open && idx >= 0 && rows[idx]) { pick(rows[idx]); } else { setOpen(false); onSearch(value); } }
  };
  const Row = ({ r, i }) => (
    <li><button type="button" onMouseDown={(e) => { e.preventDefault(); pick(r); }} onMouseEnter={() => setIdx(i)} data-testid={`hero-suggest-${r.kind}-${i}`}
      className={`w-full text-left px-4 py-2 text-sm flex items-center gap-2 transition-colors ${idx === i ? "bg-gold/15" : "hover:bg-gold/10"}`}>
      {r.kind === "cat" ? <Tag className="w-4 h-4 text-[#C98A3C] shrink-0"/> : <UserRound className="w-4 h-4 text-aic-navy shrink-0"/>}
      <span className="font-semibold text-aic-navy truncate">{r.kind === "cat" ? r.label : r.name}</span>
      <span className="text-xs text-slate-500 truncate">{r.kind === "cat" ? `${r.macro ? `· ${r.macro}` : "· macro-categoria"} · ${r.area === "artist" ? "Artisti" : "Fornitori"}` : `· ${r.macroCategory}${r.city ? ` · ${r.city}` : ""}`}</span>
    </button></li>
  );
  return (
    <div className="relative">
      <input data-testid="hero-query" value={value} autoComplete="off" onChange={(e) => { onChange(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} onKeyDown={onKey}
        placeholder='es. "cover band" o "Mario Rossi"' className={className}/>
      {open && rows.length > 0 && (
        <ul className="absolute z-40 mt-1 w-full min-w-[300px] bg-white border border-slate-200 rounded-2xl shadow-xl py-1 max-h-80 overflow-y-auto" data-testid="hero-suggestions">
          {sug.categories.length > 0 && <li className="px-4 pt-2 pb-1 overline text-slate-400">Categorie</li>}
          {rows.map((r, i) => <React.Fragment key={`${r.kind}${r.id || r.label}`}>
            {r.kind === "prov" && i === sug.categories.length && <li className="px-4 pt-2 pb-1 overline text-slate-400">Artisti e fornitori</li>}
            <Row r={r} i={i}/>
          </React.Fragment>)}
        </ul>
      )}
    </div>
  );
};
